import { types } from 'mobx-state-tree';

export const settingsStore = types.model(
	'Settings', {
		dummy: false
	})
	.actions(self => ({
		onDummyChange() {
			self.dummy = !self.dummy;
		},
	}))
	.create();
